module.exports = __webpack_public_path__ + "img/serious_illness.7753cd9.svg";